import { CloseButton, Divider, Group, Stack } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import PageTitle from "../../../../components/View/PageTitle";
import LinkedinAccount from "../../tools/linkedin/components/LinkedinAccount";

const LinkedinPageCreate = () => {
  const { poolId } = useParams();
  const lang = useLanguage((s) => s.language);

  const navigate = useNavigate();
  const handleClose = () => {
    if (poolId) {
      navigate(`/senders/pool/${poolId}/linkedin/none`);
    } else {
      navigate(`/senders/linkedin/none`);
    }
  };

  return (
    <Stack
      mx={"auto"}
      mt={32}
      p={16}
      mb={32}
      gap={"xs"}
      w={"60%"}
      style={{
        boxShadow: "#00000016 0 2px 6px",
        background: "#fff",
        borderRadius: 12,
        width: "90%",
        overflow: "hidden"
      }}
      h={"calc(100vh - 128px)"}
      pos={"relative"}
    >
      <Group>
        <CloseButton size={40} onClick={handleClose} />
        <PageTitle title={lang.linkedin_accounts.create.button_tooltip} />
      </Group>
      <Divider />
      <LinkedinAccount onCreated={handleClose} isPage />
    </Stack>
  );
};

export default LinkedinPageCreate;
